import { Component, OnInit } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { HttpService } from '../../../services/http/http.service';
import { Ng4LoadingSpinnerService } from 'ng4-loading-spinner';
import { MatSnackBar } from '@angular/material';
import { isGeneratedFile } from '@angular/compiler/src/aot/util';

@Component({
  selector: 'app-navigator',
  templateUrl: './navigator.component.html',
  styleUrls: ['./navigator.component.scss']
})
export class NavigatorComponent implements OnInit {
  campaignId;
  campaignType;
  referralType;
  constructor(private router: Router, private activatedRoute: ActivatedRoute,
    private httpService: HttpService,
    private spinnerService: Ng4LoadingSpinnerService, private snackbar: MatSnackBar) {
    this.activatedRoute.queryParams.subscribe(params => {
      console.log("params",params);
      
      if (params['cid']) {
        this.campaignId = params['cid'];
        this.campaignType = params['type'];
        this.referralType = params['refType']
        console.log("this.campaignId", this.campaignId);

        localStorage.setItem('campaignId', this.campaignId);
        localStorage.setItem('campaignType', this.campaignType);
        localStorage.setItem('referralType', this.referralType);
      } else {
        this.campaignId = null;
      }
      console.log('cid', this.campaignId);
    });

  }

  ngOnInit() {

    if (this.campaignType !== null && this.campaignType !== undefined && this.campaignType.trim() === 'mcq') {
      this.router.navigate(['register'], { queryParams: { cid: this.campaignId } });
    }
    else {
      if (this.referralType !== "" && this.referralType !== undefined && this.referralType !== null) {
        this.router.navigate(['apply'], { queryParams: { cid: this.campaignId, referralType: this.referralType } });
      }
      else {
        this.router.navigate(['apply'], { queryParams: { cid: this.campaignId } });
      }
    }
   
  }


 
  openSnackBar(message: string) {
    if (message) {
      this.snackbar.open(message, null, {
        duration: 2000,
      });
    } else {
      this.snackbar.open('Network Error', null, {
        duration: 2000,
      });
    }
  }
}
